(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@ant-design/icons-vue"), require("ant-design-vue"), require("axios"), require("vue"), require("vue-types"));
	else if(typeof define === 'function' && define.amd)
		define(["@ant-design/icons-vue", "ant-design-vue", "axios", "vue", "vue-types"], factory);
	else if(typeof exports === 'object')
		exports["captcha"] = factory(require("@ant-design/icons-vue"), require("ant-design-vue"), require("axios"), require("vue"), require("vue-types"));
	else
		root["captcha"] = factory(root["@ant-design/icons-vue"], root["ant-design-vue"], root["axios"], root["vue"], root["vue-types"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__868__, __WEBPACK_EXTERNAL_MODULE__955__, __WEBPACK_EXTERNAL_MODULE__300__, __WEBPACK_EXTERNAL_MODULE__748__, __WEBPACK_EXTERNAL_MODULE__210__) => {
return 